/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  CreateCouponPaymentOptions,
  CreateCouponPaymentResponses,
} from '../types/CreateCouponPayment'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Create a coupon payment for a bond asset
 * {@link /v1/assets/:asset_id/coupon_payments}
 * @deprecated
 */
export function createCouponPayment<ThrowOnError extends boolean = true>(
  options: Options<CreateCouponPaymentOptions, ThrowOnError>,
): Unwrappable<RequestResult<CreateCouponPaymentResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/assets/{asset_id}/coupon_payments',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CreateCouponPaymentResponses, ThrowOnError>>,
  )
}
